<!-- 我的消息 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('阅读人员')">
              <j-select-user-by-dep v-model="queryParam.userNames" @change="sendChange" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('业务类型')">
              <a-select v-model="queryParam.busType" :placeholder="$t('请选择业务类型')">
                <a-select-option :value="0">{{ $t('通告') }}</a-select-option>
                <a-select-option :value="1">{{ $t('流程') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAll" type="primary" icon="eye">{{ $t('全部已读') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record,'detail')">{{ $t('查看') }}</a>
        </span>

      </a-table>
    </div>

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from './Announcement/administrationNoticeModal'
  import { postAction,getAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSelectUserByDep from "@/components/jeecgbiz/JSelectUserByDep"
  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      JSelectDepart,
      JSelectUserByDep
    },
    data () {
      return {
        url: {
          list: "/jeecg-oa/notice/oaAnnouncement/list",
          delete: "/jeecg-oa/notice/oaAnnouncement/delete",
          deleteBatch: "/jeecg-oa/notice/oaAnnouncement/deleteBatch",
          updateReadStateById: "/jeecg-oa/notice/oaAnnouncement/updateReadStateById",
          updateReadStateByUser: "/jeecg-oa/notice/oaAnnouncement/updateReadStateByUser",
          queryById: "/jeecg-oa/notice/bsAnnounce/queryById"
        },
        dictOptions:{},
        superFieldList:[],
        queryParam:{
          bpmStatus: 1
        }
      }
    },
    created() {},
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('消息类型'),
            align:"center",
            dataIndex: 'msgCategory',
            customRender: (t, r, index) => {
              if(t == 1){
                return this.$t('通知公告')
              }else{
                return this.$t('系统消息')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('公告类型'),
            align:"center",
            dataIndex: 'announceSecondName',
            width:150,
            ellipsis: true,
            // customRender:function (t,r,index) {
            //   if(t == 1){
            //     return '行政公告'
            //   }
            // }
          },
          {
            title: this.$t('公告标题'),
            align:"center",
            dataIndex: 'titile',
            width:300,
            ellipsis: true,
          },
          {
            title: this.$t('优先级'),
            align:"center",
            dataIndex: 'priority',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('阅读人员'),
            align:"center",
            dataIndex: 'userNames',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('业务类型'),
            align:"center",
            dataIndex: 'busType',
            customRender: (t, r, index) => {
              if(t == 0){
                return this.$t('通告')
              }else{
                return this.$t('流程')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('阅读状态'),
            align:"center",
            dataIndex: 'readState',
            customRender: (t, r, index) => {
              if(t == 0){
                return this.$t('未读')
              }else{
                return this.$t('已读')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ];
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      searchReset(){
        this.queryParam = {
          bpmStatus: 1
        };
        this.loadData();
      },
      handleAdd(){
        this.$nextTick(()=>{
          this.$refs.modalForm.init({});
        });
      },
      handleEdit(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'edit');
        });
      },
      handleDetail(row){
        this.$nextTick(()=>{
          if(row.busType == 0){
            getAction(this.url.queryById,{id:row.busId}).then(res=>{
              if(res.success){
                this.$refs.modalForm.init(res.result,'detail');
              }
            });
            getAction(this.url.updateReadStateById,{id:row.id}).then(res=>{
              if(res.success){
                this.loadData();
              }
            })
          }else{
            this.$router.push({
              path: '/OAoffice/flowable/task/todo/index'
            });
          }
        });
      },
      handleAll(){
        getAction(this.url.updateReadStateByUser,{id:this.selectedRowKeys.join(',')}).then(res=>{
          if(res.success){
            this.loadData();
          }
        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>